import { ReactComponent as LoaderDotsIcon } from '../../assets/loader-dots.svg';

interface DotLoaderProps {
  style?: React.CSSProperties;
}

const DotLoader: React.FC<DotLoaderProps> = ({ style }) => {
  return (
    <div
      style={{
        fill: 'var(--neutral-13)',
        fillOpacity: 0.45,
        height: '24px',
        width: '32px',
        ...style,
      }}
    >
      <LoaderDotsIcon />
    </div>
  );
};

export default DotLoader;
